import React from 'react';
import ContentLoader from 'react-content-loader';

// skeletonreact.com
const OrderInfoLoader = (props: any) => (
    <ContentLoader
        speed={2}
        width={130}
        height={110}
        viewBox="0 0 130 110"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        title="Bezig met laden..."
        {...props}
    >
        <rect x="15" y="10" rx="3" ry="3" width="130" height="10" />
        <rect x="15" y="30" rx="3" ry="3" width="130" height="10" />
        <rect x="15" y="50" rx="3" ry="3" width="130" height="10" />
    </ContentLoader>
);

export default OrderInfoLoader;
